module.exports = __webpack_public_path__ + "media/images/underline-white-1d6bd856fd9a6a4f3a0911eb71017bb6.svg";